import './ui.css';

const STATUS_MAP = {
  pending: { label: 'Pendiente', tone: 'warning' },
  approved: { label: 'Aprobado', tone: 'success' },
  rejected: { label: 'Rechazado', tone: 'danger' },
  active: { label: 'Activo', tone: 'success' },
  draft: { label: 'Borrador', tone: 'muted' },
  archived: { label: 'Archivado', tone: 'muted' },
};

/** Insignia de estado (registros y formularios comparten estilo). */
export default function StatusBadge({ status }) {
  const info = STATUS_MAP[status] ?? { label: status, tone: 'muted' };
  return <span className={`status-badge status-badge--${info.tone}`}>{info.label}</span>;
}
